<template>
  <div class="administratorsList" >
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="value"
          multiple 
          filterable
          clearable
          collapse-tags
          >
            <!-- <el-option key :label="$t('lang.villageall')" value="0"></el-option> -->
            <el-checkbox
                v-model="check"
                class="m-l-20"
                :indeterminate="value !== villageList.length"
                @change="selectAll"
              >
                全&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;选
              </el-checkbox>
            <el-option
              v-for="(item,index) in villageList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="collect">
            <span class="demonstration">费用期间:</span>
            <el-date-picker
              v-model="period"
              type="month"
              value-format="timestamp"
              placeholder="费用期间">
            </el-date-picker>
          </div>
        </el-form-item>
         <el-form-item>
          <div class="collect">
            <span>业务日期:</span>
            <el-date-picker
              v-model="createTimeTs"
              type="date"
              value-format="timestamp"
              placeholder="业务日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="collect">
            <span>统计维度：</span>
            <el-radio-group v-model='latitude' @change="latitudeChange">
              <el-radio  label="1">收费项目</el-radio>
              <el-radio  label="2">业务属性+收费项目</el-radio>
              <el-radio  label="3">管家+收费项目</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-switch style="margin-left: 10px; margin-right: 10px;" v-if="isRelationButton==1" active-text="收费减免" v-model="switchValue"> </el-switch>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      </el-form>
    </div>
    <el-card class="rateBase">
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight655 : require('@/config/enum').tableheight655"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.administratorsListcheckbox"></el-table-column>
        <!-- <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column> -->
        <el-table-column prop="staffName" v-if="this.latitude==3" label="管家" ></el-table-column>
        <el-table-column prop="feeName" :label="$t('lang.feePay.lab_feeConfigName')"></el-table-column>
        <el-table-column label="本期" align='center'>
          <el-table-column prop="receiveAmountCount" :label="$t('lang.lab_currentReceive')">
              <template slot-scope="scope">{{scope.row.receiveAmountCount|rounding}}</template>
          </el-table-column>
          <el-table-column prop="paidAmountCount" :label="$t('lang.lab_currentReceived')">
              <template slot-scope="scope">{{scope.row.paidAmountCount|rounding}}</template>
          </el-table-column>
          <el-table-column prop="revAmountCount" :label="$t('lang.lab_currentArrear')">
            <template slot-scope="scope">{{scope.row.revAmountCount|rounding}}</template>
          </el-table-column>
          <el-table-column prop="thisPeriodRate" :label="$t('lang.lab_currentRate')"></el-table-column>
        </el-table-column>
          <el-table-column label="本年往期" align='center'>
          <el-table-column prop="receiveAmountCount1" :label="$t('lang.lab_currentYearPast')">
             <template slot-scope="scope">{{scope.row.receiveAmountCount1|rounding}}</template>
          </el-table-column>
          <el-table-column prop="paidAmountCount1" :label="$t('lang.lab_currentYearReceivedPast')">
             <template slot-scope="scope">{{scope.row.paidAmountCount1|rounding}}</template>
          </el-table-column>
          <el-table-column prop="revAmountCount1" :label="$t('lang.lab_currentYearPastArrear')">
            <template slot-scope="scope">{{scope.row.revAmountCount1|rounding}}</template>
          </el-table-column>
          <el-table-column prop="thisPeriodRate1" :label="$t('lang.lab_currentYearPastRate')"></el-table-column>
        </el-table-column>
        <el-table-column label="本年" align='center'>
          <el-table-column prop="receiveAmountCount2" :label="$t('lang.lab_currentYearReceive')">
            <template slot-scope="scope">{{scope.row.receiveAmountCount2|rounding}}</template>
          </el-table-column>
          <el-table-column prop="paidAmountCount2" :label="$t('lang.lab_currentYearReceived')">
            <template slot-scope="scope">{{scope.row.paidAmountCount2|rounding}}</template>
          </el-table-column>
          <el-table-column prop="revAmountCount2" :label="$t('lang.lab_currentYearArrear')">
            <template slot-scope="scope">{{scope.row.revAmountCount2|rounding}}</template>
          </el-table-column>
          <el-table-column prop="thisPeriodRate2" :label="$t('lang.lab_currentYearRate')"></el-table-column>
        </el-table-column>
          <el-table-column label="往年拖欠" align='center'>
          <el-table-column prop="receiveAmountCount3" :label="$t('lang.lab_yearPastReceive')">
              <template slot-scope="scope">{{scope.row.receiveAmountCount3|rounding}}</template>
          </el-table-column>
          <el-table-column prop="paidAmountCount3" :label="$t('lang.lab_yearPastReceived')">
              <template slot-scope="scope">{{scope.row.paidAmountCount3|rounding}}</template>
          </el-table-column>
          <el-table-column prop="revAmountCount3" :label="$t('lang.lab_yearPastArrear')">
            <template slot-scope="scope">{{scope.row.revAmountCount3|rounding}}</template>
          </el-table-column>
          <el-table-column prop="thisPeriodRate3" :label="$t('lang.lab_yearPastRate')">
            <template slot-scope="scope">{{scope.row.thisPeriodRate3}}</template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
  import {
    excelDownload
  } from '../../../config/download.js'
/**
 *@ClassName:
 *@Description:管理员列表
 *@author:xubz
 *@Copyright:格众科技
 *@date:2021-12-15
 */
export default {
  name:'/manage/main.adminList',
  data() {
    return {
      check:0,
      isRelationButton:this.$store.getters.isRelationButton,
      switchValue:false,
      latitude: '1',
      createTimeTs: '',
      period: '',
      input: '', // 关键字
      value: [], // 小区绑定值
      pageCount: 0, // 总页数
      pageNum: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      villageList: [], // 小区下拉列表
      administratorsListcheckbox: require('@/config/enum')
        .administratorsListcheckbox, // 是否隐藏复选框
      total:{
                receiveAmountCount: "",
                paidAmountCount: "",
                revAmountCount: "",
                thisPeriodRate:"",
                receiveAmountCount1: "",
                paidAmountCount1: "",
                revAmountCount1: "",
                thisPeriodRate1: "",
                receiveAmountCount2: "",
                paidAmountCount2: "",
                revAmountCount2: "",
                thisPeriodRate2: "",
                receiveAmountCount3: "",
                paidAmountCount3: "",
                revAmountCount3: "",
                thisPeriodRate3: "",
                feeName: "合计"    
        }  
    }
  },
  created() {
    console.log(this.$store.getters.isRelationButton)
    this.getDatePicker()
    this.gardens()
    this.value.push (this.$store.getters.gardenId) 
    this.collectionRateDetail()
  },
  filters: {
    rounding (value) {
      if (value == undefined || value == ''||value == null) {
          value = 0
      }
     return value.toFixed(2)
    }

  },
  methods: {
    selectAll (checked) {
      if (checked) {
        this.value = this.villageList.map(d => d.id)
      } else {
        this.value = []
      }
    },
     // 表格下载
     excelDownloadClick() {
        if (navigator.onLine) {
          const tHeader=[]
          const filterVal=[]
          if(this.latitude!=3){
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.feePay.lab_feeConfigName'),
            this.$i18n.t('lang.lab_currentReceive'),
            this.$i18n.t('lang.lab_currentReceived'),
            this.$i18n.t('lang.lab_currentArrear'),
            this.$i18n.t('lang.lab_currentRate'),
            this.$i18n.t('lang.lab_currentYearPast'),
            this.$i18n.t('lang.lab_currentYearReceivedPast'),
            this.$i18n.t('lang.lab_currentYearPastArrear'),
            this.$i18n.t('lang.lab_currentYearPastRate'),
            this.$i18n.t('lang.lab_currentYearReceive'),
            this.$i18n.t('lang.lab_currentYearReceived'),
            this.$i18n.t('lang.lab_currentYearArrear'),
            this.$i18n.t('lang.lab_currentYearRate'),
            this.$i18n.t('lang.lab_yearPastReceive'),
            this.$i18n.t('lang.lab_yearPastReceived'),
            this.$i18n.t('lang.lab_yearPastArrear'),
            this.$i18n.t('lang.lab_yearPastRate')
          ]
            // 对应table数据的列字段名
            const filterVal = ['feeName', 'receiveAmountCount', 'paidAmountCount', 'revAmountCount', 'thisPeriodRate', 'receiveAmountCount1', 'paidAmountCount1',
            'revAmountCount1','thisPeriodRate1','receiveAmountCount2','paidAmountCount2','revAmountCount2','thisPeriodRate2','receiveAmountCount3','paidAmountCount3',
            'revAmountCount3','thisPeriodRate3' 
            ]
            excelDownload(tHeader, filterVal, this.tableData, "收缴率统计表")
          }else {
            const tHeader = [
            this.$i18n.t('lang.lab_housekeeper'),
            this.$i18n.t('lang.feePay.lab_feeConfigName'),
            this.$i18n.t('lang.lab_currentReceive'),
            this.$i18n.t('lang.lab_currentReceived'),
            this.$i18n.t('lang.lab_currentArrear'),
            this.$i18n.t('lang.lab_currentRate'),
            this.$i18n.t('lang.lab_currentYearPast'),
            this.$i18n.t('lang.lab_currentYearReceivedPast'),
            this.$i18n.t('lang.lab_currentYearPastArrear'),
            this.$i18n.t('lang.lab_currentYearPastRate'),
            this.$i18n.t('lang.lab_currentYearReceive'),
            this.$i18n.t('lang.lab_currentYearReceived'),
            this.$i18n.t('lang.lab_currentYearArrear'),
            this.$i18n.t('lang.lab_currentYearRate'),
            this.$i18n.t('lang.lab_yearPastReceive'),
            this.$i18n.t('lang.lab_yearPastReceived'),
            this.$i18n.t('lang.lab_yearPastArrear'),
            this.$i18n.t('lang.lab_yearPastRate')
          ]
            // 对应table数据的列字段名
            const filterVal = ['staffName','feeName', 'receiveAmountCount', 'paidAmountCount', 'revAmountCount', 'thisPeriodRate', 'receiveAmountCount1', 'paidAmountCount1',
            'revAmountCount1','thisPeriodRate1','receiveAmountCount2','paidAmountCount2','revAmountCount2','thisPeriodRate2','receiveAmountCount3','paidAmountCount3',
            'revAmountCount3','thisPeriodRate3' 
            ]
            excelDownload(tHeader, filterVal, this.tableData, "收缴率统计表")
          }  
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      latitudeChange(){
          this.tableData=[]
      },
     getDatePicker() {
      let d = new Date()
      let year1, month1
      [year1, month1] = [d.getFullYear(), d.getMonth()]
      let date1 = new Date(year1, month1).getTime()
      // this.datevalues.push(Date.parse(date1))
      this.period = date1
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 小区下拉
    gardens() {
      // let loading = this.$loading()
      // this.$get(`/gardens`).then(
      //   res => {
      //     loading.close()
      //     if (res && res.errCode === 0) {
      //       this.villageList = res.list
      //     }
      //   },
      //   error => {
      //     loading.close()
      //     this.$message.error(error)
      //   }
      // )
      let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.villageList = myGardens
    
    },
    // 管理员列表
    collectionRateDetail() {
       if(this.value.length==0){
          this.$message.info('请选择园区')
          return
       }
        if(this.period==''||this.period==undefined){
          this.$message.info('费用期间不能为空')
          return
       }
      let loading = this.$loading()
       let params = {
        gardenId:this.value.toString(),
        period: this.period,
        createTimeTs: this.createTimeTs,
        latitude: this.latitude,
        isWaiver: this.switchValue
      }
      this.$get(
        `/selectCollectionRateDetail/`,params
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            if(res.latitude==3){
              let arry=[]
              for(let i = 0; i < res.list.length; i++){
                var receiveAmountCount=0,paidAmountCount=0,revAmountCount=0,receiveAmountCount1=0,paidAmountCount1=0,revAmountCount1=0,receiveAmountCount2=0,paidAmountCount2=0,revAmountCount2=0,receiveAmountCount3=0,paidAmountCount3=0,revAmountCount3=0
                var x=0
                arry.push(res.list[i])
                  for (let j = (i + 1); j < res.list.length; j++) {
                      if(res.list[i].staffId==res.list[j].staffId){
                          x=1
                          arry.push(res.list[j])
                          console.log(arry)
                          receiveAmountCount+=res.list[j].receiveAmountCount
                          paidAmountCount+=res.list[j].paidAmountCount 
                          revAmountCount+=res.list[j].revAmountCount
                          receiveAmountCount1+=res.list[j].receiveAmountCount1 
                          paidAmountCount1+=res.list[j].paidAmountCount1
                          revAmountCount1+=res.list[j].revAmountCount1
                          receiveAmountCount2+=res.list[j].receiveAmountCount2 
                          paidAmountCount2+=res.list[j].paidAmountCount2
                          revAmountCount2+=res.list[j].revAmountCount2
                          receiveAmountCount3+=res.list[j].receiveAmountCount3 
                          paidAmountCount3+=res.list[j].paidAmountCount3
                          revAmountCount3+=res.list[j].revAmountCount3
                          res.list.splice(j,1)
                      }  
                  }
                  if(x==1){
                    let total={
                          receiveAmountCount:res.list[i].receiveAmountCount+receiveAmountCount,
                          paidAmountCount: res.list[i].paidAmountCount+paidAmountCount,
                          revAmountCount:  res.list[i].revAmountCount+revAmountCount,
                          thisPeriodRate:((res.list[i].paidAmountCount+paidAmountCount)/(res.list[i].receiveAmountCount+receiveAmountCount)*100).toFixed(2)+"%",
                          receiveAmountCount1: res.list[i].receiveAmountCount1+receiveAmountCount1,
                          paidAmountCount1: res.list[i].paidAmountCount1+paidAmountCount1,
                          revAmountCount1: res.list[i].revAmountCount1+revAmountCount1,
                          thisPeriodRate1: res.list[i].receiveAmountCount1==0? "0.00%":((res.list[i].paidAmountCount1+paidAmountCount1)/(res.list[i].receiveAmountCount1+receiveAmountCount1)*100).toFixed(2)+"%",
                          receiveAmountCount2: res.list[i].receiveAmountCount2+receiveAmountCount2,
                          paidAmountCount2: res.list[i].paidAmountCount2+paidAmountCount2,
                          revAmountCount2: res.list[i].revAmountCount2+revAmountCount2,
                          thisPeriodRate2: ((res.list[i].paidAmountCount2+paidAmountCount2)/(res.list[i].receiveAmountCount2+receiveAmountCount2)*100).toFixed(2)+"%",
                          receiveAmountCount3: res.list[i].receiveAmountCount3+receiveAmountCount3,
                          paidAmountCount3: res.list[i].paidAmountCount3+paidAmountCount3,
                          revAmountCount3: res.list[i].revAmountCount3+revAmountCount3,
                          thisPeriodRate3:res.list[i].receiveAmountCount3==0? "0.00%":((res.list[i].paidAmountCount3+paidAmountCount3)/(res.list[i].receiveAmountCount3+receiveAmountCount3)*100).toFixed(2)+"%",
                          feeName: "合计"    
                  }  
                      arry.push(total)
                  }else{
                   var bb =  ((res.list[i].paidAmountCount3)/(res.list[i].revAmountCount3)*100).toFixed(2)+"%"
                    let total={
                          receiveAmountCount:  res.list[i].receiveAmountCount,
                          paidAmountCount:     res.list[i].paidAmountCount,
                          revAmountCount:      res.list[i].revAmountCount,
                          thisPeriodRate:      res.list[i].thisPeriodRate,
                          receiveAmountCount1: res.list[i].receiveAmountCount1,
                          paidAmountCount1:    res.list[i].paidAmountCount1,
                          revAmountCount1:     res.list[i].revAmountCount1,
                          thisPeriodRate1:     res.list[i].thisPeriodRate1,
                          receiveAmountCount2: res.list[i].receiveAmountCount2,
                          paidAmountCount2:    res.list[i].paidAmountCount2,
                          revAmountCount2:     res.list[i].revAmountCount2,
                          thisPeriodRate2:     res.list[i].thisPeriodRate2,
                          receiveAmountCount3: res.list[i].receiveAmountCount3,
                          paidAmountCount3:    res.list[i].paidAmountCount3,
                          revAmountCount3:     res.list[i].revAmountCount3,
                          thisPeriodRate3:     res.list[i].thisPeriodRate3,
                          feeName: "合计"    
                  }  
                      arry.push(total)
                  }
                   console.log(arry)
              }  
              this.tableData=arry
            }else{
              this.tableData=res.list
            }
          
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.collectionRateDetail()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.collectionRateDetail()
    },
    commit() {
      this.pageNum = 1
      this.collectionRateDetail()
    }
  }
}
</script>

<style lang="scss" scope>


.rateBase .el-table--border th, .el-table__fixed-right-patch {
    border-bottom: 1px solid #bfc2c7;
}
.rateBase  .el-table--border th {
    border-right: 1px solid #c7c9cd;;
}
.collect{
  margin-left:40px;
}
</style>